module.exports = __webpack_public_path__ + "static/g1-8d948075e03d0f94f4aeb0ba8aab1a52.svg";